import { Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from './search.service'; // Update path as necessary
import { PARAMS } from 'src/app/_configs/params';
import { TenderService } from 'src/app/modules/tenders/_services/tender.service';
import { StripMarginService } from '../../_services/strip-margin.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class SearchBarComponent implements OnInit {
  @Output() searchSelected: EventEmitter<string> = new EventEmitter<string>();
  @Input() display: any;
  stripMargin: boolean = true;
  searchQuery: any;
  isHeaderSearchClassActive: boolean = false;
  dropdownOptions: any[] = [];
  searchData: any;
  shouldShowTrialBanner: boolean = false;
  constructor(private router: Router, private searchService: SearchService, private tenderService: TenderService,
    private stripMarginService: StripMarginService, private authService: AuthService, private activatedRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.stripMarginService.stripMargin$.subscribe(
      (value) => {
        this.stripMargin = value;
      }
    );
    this.verifySearchBarCond();
    this.checkTrialBanner();
  }
  async checkTrialBanner() {
    const { show } = await this.authService.shouldShowTrialBanner();
    this.shouldShowTrialBanner = show;

  }
  verifySearchBarCond() {
    if (this.router.url.split('?')[0] !== PARAMS.ROUTING_PATHS.HOME && this.router.url.split('?')[0] !== PARAMS.ROUTING_PATHS.ABOUT_US) {
      this.isHeaderSearchClassActive = true
    }
    else {
      this.isHeaderSearchClassActive = false
    }
  }

  onKeyUp(event: KeyboardEvent): void {
    const query = (event.target as HTMLInputElement).value;
    if (query.length >= 2) {
      this.keyUpSearch();
    } else {
      this.dropdownOptions = []; // Clear suggestions if less than 2 characters
    }
  }

  keyUpSearch(): void {
    this.tenderService.search(this.searchQuery).subscribe((res: any) => {
      this.searchData = res?.data;
      this.dropdownOptions = this.searchData; // Adjust based on your API response
    });
  }

  // Method to highlight search text in the dropdown options
  highlightText(text: string, query: string): string {
    if (!query) {
      return text;
    }
    // Escape special characters for regex
    const escapedQuery = query.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const regex = new RegExp(`(${escapedQuery})`, 'gi');
    return text.replace(regex, '<strong>$1</strong>');
  }

  searchTenders(): void {
    if (this.searchQuery) {
      this.dropdownOptions = [];
      this.searchService.updateSearchQuery(this.searchQuery); // Update the search query in shared service

      this.router.navigate([PARAMS.ROUTING_PATHS.ALL_TENDERS_ACTIVE], {
        relativeTo: this.activatedRoute,
        queryParams: {
          [PARAMS.STATIC_PARAMS.QUERY_TYPE_SEARCH]: "",
          [PARAMS.STATIC_PARAMS.QUERY_KEY]: this.searchQuery
        },
        queryParamsHandling: 'merge',
      });
      this.dropdownOptions = [];
    }
  }

  navigateToResult(searchLink: any): void {
    this.router.navigate([searchLink]);
    this.dropdownOptions = [];
  }

  onSearchSelect(searchLink: any): void {
    this.searchSelected.emit(searchLink);  // Emit the search value to the parent
    this.dropdownOptions = [];
  }

}
